export const getCurrentTimeStamp = () =>
  new Date().toISOString();
